import { defineStore } from "pinia";

interface State {
  tinyConfig: unknown;
}

export const useTinyConfigStore = defineStore("tinyConfig", {
  state: (): State => ({
    tinyConfig: undefined,
  }),

  actions: {
    setTinyConfig(tinyConfig: unknown) {
      this.tinyConfig = tinyConfig;
    },
  },
});
